<template>
  <div class="gf_pricing__banner__box">
    <div class="gf_pricing__banner__one">
      <div class="gf_pricing__banner__one__top">
        <div class="gf_pricing__banner__one__top-text">
          <p class="gf_pricing__banner__title">{{ $t("dataNewPlan.banner.title") }}</p>
          <p class="gf_pricing__banner__desc">{{ $t("dataNewPlan.banner.desc") }}</p>
        </div>
        <div class="gf_pricing__banner__one__top-image">
          <img
            src="https://s3-ap-southeast-1.amazonaws.com/gemtickets/production/dashboard/3c1b7d6f-efe8-4be2-949a-ba1c36176257.png"
            alt=""
          />
        </div>
      </div>
      <div class="gf_pricing__banner__one__bottom">
        <img
          src="https://s3-ap-southeast-1.amazonaws.com/gemtickets/production/dashboard/efa51bbb-45c3-4d79-8ec4-3278c62b8081.png"
          alt=""
          srcset=""
        />
      </div>
    </div>
    <div class="gf_pricing__banner__two">
      <img
        src="https://s3-ap-southeast-1.amazonaws.com/gemtickets/production/dashboard/1d06cb8b-12d7-459b-8e64-0a363a059f65.png"
        alt=""
        srcset=""
      />
    </div>
    <div class="gf_pricing__banner__three">
      <img
        src="https://s3-ap-southeast-1.amazonaws.com/gemtickets/production/dashboard/76708e9c-7151-4452-a778-daa921965325.png"
        alt=""
        srcset=""
      />
      <img
        src="https://s3-ap-southeast-1.amazonaws.com/gemtickets/production/dashboard/935088af-e034-4521-b3b5-6e03497c6981.png"
        alt=""
        srcset=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Pricingbanner",
  computed: {},
};
</script>

<style lang="scss" scoped>
.gf_pricing__banner {
  &__box {
    display: flex;
    flex-wrap: nowrap;
    margin-top: 80px;
  }
  &__one {
    width: 563px;
    margin-right: 20px;
    @media (max-width: 1230px) {
      width: 588.5px;
      min-width: 588.5px;
    }
    &__top {
      display: flex;
      margin-bottom: 20px;
      height: 195px;
      @media (max-width: 1230px) {
        height: 202px;
      }
      &-text {
        flex: 1;
        text-align: left;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        p:first-child {
          font-weight: 700;
          font-size: 48px;
          line-height: 120%;
          margin-bottom: 8px;
          color: map-get($text-light-mode, "high-contrast");
        }
        p:last-child {
          font-weight: 400;
          font-size: 16px;
          line-height: 150%;
          color: map-get($text-light-mode, "high-contrast");
        }
      }
      &-image {
        width: 227px;
        border-radius: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    &__bottom {
      border-radius: 10px;
      @media (max-width: 1230px) {
        height: 248px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  &__two {
    min-width: 299px;
    width: 299px;
    height: 454px;
    margin-right: 20px;
    @media (max-width: 1230px) {
      width: 314.5px;
      height: 471px;
      margin-right: 0px;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  &__three {
    flex: 1;
    display: flex;
    flex-direction: column;
    img {
      width: 100%;
      border-radius: 10px;
      &:first-child {
        width: 298px;
        height: 269px;
        margin-bottom: 20px;
      }
      &:last-child {
        width: 298px;
        height: 165px;
      }
    }
    @media (max-width: 1230px) {
      display: none;
    }
  }
}
</style>
